import { render, staticRenderFns } from "./company.vue?vue&type=template&id=b75f5520&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"
import style0 from "./company.vue?vue&type=style&index=0&id=b75f5520&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75f5520",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b75f5520')) {
      api.createRecord('b75f5520', component.options)
    } else {
      api.reload('b75f5520', component.options)
    }
    module.hot.accept("./company.vue?vue&type=template&id=b75f5520&scoped=true", function () {
      api.rerender('b75f5520', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/company.vue"
export default component.exports